import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

export default function SectionHow() {
  const { t } = useTranslation();
  // Text content object for easy modification
  const STEP_CONTENT = {
    steps: [
      {
        number: '1',
        titleKey: t('SECTION_HOW_STEP_1_TITLE'),
        descKey: t('SECTION_HOW_STEP_1_DESC'),
        circleColor: 'blue',
      },
      {
        number: '2',
        titleKey: t('SECTION_HOW_STEP_2_TITLE'),
        descKey: t('SECTION_HOW_STEP_2_DESC'),
        circleColor: 'pink',
      },
      {
        number: '3',
        titleKey: t('SECTION_HOW_STEP_3_TITLE'),
        descKey: t('SECTION_HOW_STEP_3_DESC'),
        circleColor: 'blue',
      },
      {
        number: '4',
        titleKey: t('SECTION_HOW_STEP_4_TITLE'),
        descKey: t('SECTION_HOW_STEP_4_DESC'),
        circleColor: 'pink',
      },
    ],
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('SECTION_HOW_TITLE')}</h2>

      <div className={styles.stepsContainer}>
        {STEP_CONTENT.steps.map((step, index) => (
          <div key={index} className={styles.stepItem}>
            <div className={`${styles.numberCircle} ${styles[step.circleColor]}`}>
              <span className={styles.number}>{step.number}</span>
            </div>

            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>{step.titleKey}</h3>
              <p className={styles.stepDescription}>{step.descKey}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
